<div class="modal-header d-flex justify-content-between align-items-center">
  <h4 class="modal-title mb-0">Documents</h4>
  <div class="d-flex align-items-center">
    <button 
      *ngIf="filesUrls && filesUrls.length > 1"
      type="button" 
      class="btn btn-primary btn-sm me-2" 
      (click)="downloadAllFiles()"
      [disabled]="isDownloadingAll">
      <span *ngIf="isDownloadingAll" class="spinner-border spinner-border-sm me-1"></span>
      {{isDownloadingAll ? 'Downloading...' : 'Download All'}}
    </button>
    <button type="button" class="close" (click)="closeModal()">
      <span>&times;</span>
    </button>
  </div>
</div>
<div class="modal-body">
  <div style="text-align:center;" *ngIf="!filesUrls || filesUrls.length<=0">
    No Data found
  </div>
  <table *ngIf="filesUrls && filesUrls.length > 0">
    <tr>
      <th>Name</th>
      <th>Preview</th>
      <th>Download</th>
    </tr>
    <tr *ngFor="let file of filesUrls">
      <td>{{file.split('/')[file.split('/').length - 1]}}</td>
      <td>
        <a href="{{blobStorageBaseUrl}}/{{file}}" target="_blank">Open</a>
      </td>
      <td>
        <a href="" (click)="downloadDocument(file,$event)">
          Download
        </a>
      </td>
    </tr>
  </table>
</div>